export default {
    AWO: 'Windhager AWO',
    WDS: 'Windhager WDS',
    WCH: 'Windhager WCH',
    WHF: 'Windhager WHF',
    WUK: 'Windhager UK',
    TBE: 'Thema BE',
    WDK: 'Windhager DK',
    WIT: 'Windhager IT',
    WUS: 'Windhager US',
    VSI: 'Veto SI',
    WES: 'Windhager ES',
    IIT: 'Imperial IT',
    TIT: 'Thermosol IT',
    WEX: 'Windhager Export',
    WSE: 'Windhager SE',
    POL: 'Bado PL',
    WEW: 'Windhager Entwicklung',
};
